import { SvgIcon } from '@mui/material';

const Coverage = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_141' data-name='Group 141' transform='translate(-7354 -6253)'>
      <circle
        id='Ellipse_2'
        data-name='Ellipse 2'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(7354 6253)'
        fill='#fff'
      />
      <g
        id='Group_18'
        data-name='Group 18'
        transform='translate(7360.078 6258.866)'
      >
        <g id='Group_18-2' data-name='Group 18'>
          <path
            id='Path_1'
            data-name='Path 1'
            d='M12.823,2.789a.714.714,0,0,0-.459-.6L6.749.078a.716.716,0,0,0-.2-.065.7.7,0,0,0-.459.069L.481,2.185a.714.714,0,0,0-.459.6c-.008.083-.671,8.29,6,11.362l.022.014a.706.706,0,0,0,.369.1l.058,0A.737.737,0,0,0,6.8,14.16C13.5,11.1,12.831,2.872,12.823,2.789m-4.5,7.023H4.73a.593.593,0,0,1-.546-.355.587.587,0,0,1,.11-.637,2.875,2.875,0,0,0,.372-.58,3.43,3.43,0,0,0,.31-.938h-.46a.585.585,0,0,1,0-1.171h.3a2.809,2.809,0,0,1-.229-1.1,1.864,1.864,0,0,1,.687-1.4,2.31,2.31,0,0,1,1.5-.549A2.531,2.531,0,0,1,7.8,3.319a2.133,2.133,0,0,1,1,.922A.592.592,0,1,1,7.758,4.8a1.21,1.21,0,0,0-.985-.535,1.14,1.14,0,0,0-.729.266.689.689,0,0,0-.271.5,1.853,1.853,0,0,0,.208.81c.04.092.082.189.119.292h.889a.585.585,0,1,1,0,1.171H6.171A4.623,4.623,0,0,1,5.79,8.628H8.323a.592.592,0,0,1,0,1.184'
            transform='translate(0 0)'
            fill='#dc0032'
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default Coverage;
